import ls from 'local-storage'
import { call, put, fork, select, takeLatest, takeEvery } from 'redux-saga/effects'
import * as types from '../types'
import * as api from '../../api'

function* getStoreList({}) {
  yield put({ type: types.STORE_SET_FETCHING_STORE_LIST })
  const { ok, data } = yield call(api.getStoreList)
  if (ok)
    yield put({ type: types.STORE_SET_STORE_LIST, data })    
  else
    yield put({ type: types.STORE_SET_FETCHING_STORE_LIST, isFetching: false })  
}

function* getActiveShift({ completeCallback }) {
  const { ok, data } = yield call(api.getActiveShifts)
  if (completeCallback) {
    if (ok)
      completeCallback(ok, data.length ? data[0] : null)
    else
      completeCallback(ok, data)
  }
}

function* startShift({ completeCallback, startParams }) {
  const { ok, data } = yield call(api.startShift, startParams)
  if (completeCallback) completeCallback(ok, data)
}

function* endShift({ key, completeCallback, endParams }) {
  const { ok, data } = yield call(api.endShift, key, endParams)
  if (completeCallback) completeCallback(ok, data)
}

function* setAvailability({ key, availability }) {
  const { ok, data } = yield call(api.setAvailability, key, availability)
}

export function* storeSaga() {
  yield takeLatest(types.STORE_ACTION_GET_STORE_LIST, getStoreList)
  yield takeLatest(types.STORE_ACTION_GET_ACTIVE_SHIFT, getActiveShift)
  yield takeLatest(types.STORE_ACTION_START_SHIFT, startShift)
  yield takeLatest(types.STORE_ACTION_END_SHIFT, endShift)
}
